import { render, staticRenderFns } from "./ModalInserirContrarrazao.vue?vue&type=template&id=8dfdbcde"
import script from "./ModalInserirContrarrazao.vue?vue&type=script&lang=js"
export * from "./ModalInserirContrarrazao.vue?vue&type=script&lang=js"
import style0 from "./ModalInserirContrarrazao.vue?vue&type=style&index=0&id=8dfdbcde&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports